import React from 'react';
import { Menu } from 'lucide-react';
import CitySelector from './CitySelector';
import NotificationBell from './NotificationBell';
import './Header.css';

const Header = ({
    title = 'Dashboard',
    connectionStatus = false,
    activeTab,
    schedulerView = 'manifest',
    setSchedulerView,
    onMenuClick,
}) => {
    const isSchedulerTab = activeTab === 'scheduler';
    // 3-way segmented control for the Scheduler tab:
    //   - manifest  : default "Schedule content by time" (SchedulerManifest)
    //   - schedules : browse all existing schedule slots (SchedulesView)
    //   - packages  : reusable content bundles (PlaylistsView, legacy name "Playlists")
    const schedulerViews = [
        { id: 'manifest',  label: 'Schedule' },
        { id: 'schedules', label: 'All slots' },
        { id: 'packages',  label: 'Packages' },
    ];

    return (
        <header
            className="app-header"
            style={{
                minHeight: '48px',
                backgroundColor: 'var(--sidebar-bg)',
                borderBottom: '1px solid var(--border-color)',
                padding: '0 32px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                position: 'sticky',
                top: 0,
                zIndex: 5,
                gap: '12px',
            }}
        >
            {/* Left: hamburger (mobile only, via CSS) + title fallback */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', minWidth: 0 }}>
                <button
                    type="button"
                    className="app-header__menu-btn"
                    onClick={onMenuClick}
                    aria-label="Open navigation"
                    style={{
                        display: 'none',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '40px',
                        height: '40px',
                        border: '1px solid var(--border-color)',
                        borderRadius: '8px',
                        background: 'transparent',
                        color: 'var(--text-secondary)',
                        cursor: 'pointer',
                        padding: 0,
                    }}
                >
                    <Menu size={20} />
                </button>
                <span
                    className="app-header__title"
                    style={{
                        display: 'none',
                        fontSize: '15px',
                        fontWeight: 600,
                        color: 'var(--text-primary)',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    }}
                >
                    {title}
                </span>
                {/* Multi-city selector — visible on every tab */}
                <CitySelector />
            </div>

            {/* Actions / Status */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
                {/* Scheduler tab: 3-way segmented control */}
                {isSchedulerTab && setSchedulerView && (
                    <div
                        role="tablist"
                        aria-label="Scheduler view"
                        style={{
                            display: 'inline-flex',
                            padding: 4,
                            border: '1px solid var(--border-color)',
                            borderRadius: 10,
                            backgroundColor: '#f8fafc',
                            gap: 4,
                        }}
                    >
                        {schedulerViews.map((v) => {
                            const active = schedulerView === v.id;
                            return (
                                <button
                                    key={v.id}
                                    type="button"
                                    role="tab"
                                    aria-selected={active}
                                    onClick={() => setSchedulerView(v.id)}
                                    style={{
                                        padding: '6px 14px',
                                        fontSize: 13,
                                        fontWeight: 600,
                                        color: active ? '#92400e' : 'var(--text-secondary, #64748b)',
                                        backgroundColor: active ? 'rgba(200, 161, 71, 0.15)' : 'transparent',
                                        border: active ? '1px solid rgba(200, 161, 71, 0.35)' : '1px solid transparent',
                                        borderRadius: 8,
                                        cursor: 'pointer',
                                        transition: 'all 0.15s',
                                    }}
                                >
                                    {v.label}
                                </button>
                            );
                        })}
                    </div>
                )}
                {/* Notification center */}
                <NotificationBell />
                {/* Connection Status */}
                {/* <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    padding: '8px 16px',
                    borderRadius: '20px',
                    backgroundColor: connectionStatus ? 'rgba(16, 185, 129, 0.1)' : 'rgba(239, 68, 68, 0.1)',
                    color: connectionStatus ? 'var(--success-color)' : 'var(--danger-color)',
                    fontSize: '14px',
                    fontWeight: '600'
                }}>
                    {connectionStatus ? <Wifi size={16} /> : <WifiOff size={16} />}
                    <span>{connectionStatus ? 'System Online' : 'Disconnected'}</span>
                </div> */}
            </div>
        </header>
    );
};

export default Header;
